import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {environment} from '../../../../../environments/environment';
import {map} from 'rxjs/operators';
import {throwError as observableThrowError, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtendimentoConfigService {
  private apiUrl = environment.apiUrl;
  private configAtendimentosUrl = `${this.apiUrl}public/atendimentos/config`;
  resultados = [];
  perdaMotivos = {};
  servicoMotivos = {};
  produtos = {};
  perfilForm = [];

  constructor(private _http: HttpClient, protected _localStorage: LocalStorage) {
  }

  getResultados(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.resultado`)
      .pipe(map(resultados => {
        if (resultados) {
          this.resultados = resultados['config_json'];
          this._localStorage.setItemSubscribe('resultados', this.resultados);
          return this.resultados;
        }
      }));
  }

  getPerdaMotivos(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.perda.motivos`)
      .pipe(map(perdaMotivos => {
        if (perdaMotivos) {
          this.perdaMotivos = perdaMotivos['config_json'];
          this._localStorage.setItemSubscribe('perdaMotivos', this.perdaMotivos);
          return this.perdaMotivos;
        }
      }));
  }

  getServicoMotivos(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.servico.motivos`)
      .pipe(map(servicoMotivos => {
        this.servicoMotivos = servicoMotivos['config_json'];
        this._localStorage.setItemSubscribe('servicoMotivos', this.servicoMotivos);
        return this.servicoMotivos;
      }));
  }

  getProdutos(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.produtos`)
      .pipe(map(produtos => {
        if (produtos) {
          this.produtos = produtos['config_json'];
          this._localStorage.setItemSubscribe('produtos', this.produtos);
          return this.produtos;
        }
      }));
  }

  getPerfilForm(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.perfil`)
      .pipe(map(perfil => {
        if (perfil) {
          this.perfilForm = perfil['config_json'];
          this._localStorage.setItemSubscribe('perfilForm', this.perfilForm);
          return this.perfilForm;
        }
      }));
  }

  getUpdate(empresaId): Observable<{}> {
    return this._http.get(`${this.configAtendimentosUrl}/${empresaId}/atendimento.update`)
      .pipe(map(update => {
        if (update) {
          return update['config_json'];
        }
      }));
  }

  setUpdate(update) {
    return this._localStorage.setItem('lastUpdate', update);
  }

  handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
